import React from "react";
import { TextInput } from "../TextInput";
import {
  withFormValidation,
  WithFormValidationProps,
} from "./withFormValidation";

interface FormTextInputProps extends WithFormValidationProps {
  label?: string;
  placeholder?: string;
  type?: string;
  required?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  width?: string | number;
}

const FormTextInput: React.FC<FormTextInputProps> = (props) => {
  const { value, ...restProps } = props;
  return <TextInput {...restProps} value={String(value || "")} />;
};

export default withFormValidation(FormTextInput);
